const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const resolveUrl = (value: string | undefined, fallback = '') => {
  const trimmed = value?.trim();
  return trimmed ? stripTrailingSlash(trimmed) : fallback;
};

export const appLinks = {
  ezTopupHomePath: resolveUrl(import.meta.env.VITE_EZTOPUP_HOME_PATH, '/home'),
  ezTopupMerchantUrl: resolveUrl(import.meta.env.VITE_EZTOPUP_MERCHANT_URL, '/?pg=merchant'),
  ezTopupFamilyPlanPath: resolveUrl(import.meta.env.VITE_EZTOPUP_FAMILY_PLAN_PATH, '/family-plan'),
  autoTopupUrl: resolveUrl(import.meta.env.VITE_EZ_AUTO_TOPUP_URL, 'https://auto.eztopup.com.mm'),
  couponTopupUrl: resolveUrl(
    import.meta.env.VITE_EZ_COUPON_TOPUP_URL,
    'https://coupon.eztopup.com.mm',
  ),
  googlePlayUrl: resolveUrl(import.meta.env.VITE_EZTOPUP_GOOGLE_PLAY_URL),
  appStoreUrl: resolveUrl(import.meta.env.VITE_EZTOPUP_APP_STORE_URL),
  huaweiAppGalleryUrl: resolveUrl(import.meta.env.VITE_EZTOPUP_HUAWEI_APP_GALLERY_URL),
};

export const isInternalLink = (url: string) => url.startsWith('/');
